import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ClipboardCheck, FileCheck2 } from 'lucide-react';
import apiClient from '@/services/apiClient';
import { fmtQ } from './PoLinePicker';

/** Delivery side: the POs / lines this delivery's bundles were counted on, and how many received bundles are still unassigned. */
export const DeliveryPoSummary = ({ entryId, refreshKey = 0, className = '' }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    let live = true;
    setD(null);
    if (!entryId) return undefined;
    apiClient.get(`/po-receipts/delivery/${entryId}`).then((r) => live && setD(r.data)).catch(() => live && setD(null));
    return () => { live = false; };
  }, [entryId, refreshKey]);
  if (!d || !d.supplier) return null;
  return (
    <div className={`rounded-lg border border-blue-200 bg-blue-50/60 p-3 text-sm ${className}`} data-testid="delivery-po-summary">
      <div className="flex items-center justify-between gap-2 mb-1.5">
        <span className="flex items-center gap-1.5 font-semibold text-blue-900"><ClipboardCheck className="w-4 h-4" />Counted on Purchase Orders</span>
        <span className={`text-xs font-medium ${d.unassigned_count ? 'text-amber-700' : 'text-emerald-700'}`} data-testid="delivery-po-unassigned">
          {d.unassigned_count ? `${d.unassigned_count} of ${d.received_bundles} received bundle(s) not on a PO yet` : `${d.received_bundles} received bundle(s) all counted`}
        </span>
      </div>
      {d.lines.length === 0 ? (
        <p className="text-xs text-gray-500" data-testid="delivery-po-none">Nothing counted on a PO yet.</p>
      ) : (
        <>
        <ul className="space-y-1">
          {d.lines.map((l) => (
            <li key={l.po_item_id} className="flex flex-wrap items-center gap-x-2 text-xs" data-testid={`delivery-po-line-${l.po_item_id}`}>
              <Link to={`/po/${l.po_id}`} className="font-mono text-blue-700 hover:underline">{l.po_number}</Link>
              <span className="text-gray-800">{l.supplier_design_name}</span>
              {l.sort_nos.length > 0 && <span className="font-mono text-purple-700">{l.sort_nos.join(', ')}</span>}
              <span className="font-semibold tabular-nums">{fmtQ(l.qty)} {l.unit}</span>
              <span className="text-gray-500">· {l.bundles.length} bundle(s)</span>
            </li>
          ))}
        </ul>
        <Link to={`/po/grn?entry=${encodeURIComponent(entryId)}`} className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-emerald-800 hover:underline" data-testid="delivery-po-grn-link">
          <FileCheck2 className="w-3.5 h-3.5" />GRN for this delivery — preview / finalise</Link>
        </>
      )}
    </div>
  );
};
